import React from "react";
import { handleContentfulLoader } from "utils/images/contentfulLoader";

type ImageSize = {
  media: string;
  src: string;
  height?: number;
  width?: number;
};

type ContentfulImageProps = {
  alt: string;
  fill?: boolean;
  style?: React.CSSProperties;
  className?: string;
  priority?: boolean;
  sizes: ImageSize[];
};

export const ContentfulResponsiveImage = ({
  alt,
  fill,
  style,
  className,
  priority,
  sizes
}: ContentfulImageProps) => {
  if (!sizes || !sizes.length) return null;
  return (
    <picture>
      {sizes.map((size) => {
        const sharedValues = {
          media: size.media,
          height: size.height,
          width: size.width
        };
        return (
          <React.Fragment key={size.media + size.src}>
            <source
              {...sharedValues}
              type="image/avif"
              srcSet={handleContentfulLoader({ src: size.src, format: "avif" })}
            />
            <source
              {...sharedValues}
              type="image/webp"
              srcSet={handleContentfulLoader({ src: size.src, format: "webp" })}
            />
          </React.Fragment>
        );
      })}
      <img
        src={handleContentfulLoader({ src: sizes?.[0]?.src ?? "" })}
        alt={alt}
        // @ts-expect-error this is a valid property
        fetchPriority={`${priority}`}
        className={className}
        style={{
          objectFit: fill ? "cover" : "inherit",
          ...style
        }}
        loading={priority ? "eager" : "lazy"}
        decoding={priority ? "auto" : "async"}
      />
    </picture>
  );
};
